import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';

//PAGES
import { EntregasPage } from '../entregas/entregas';
import { ListaGestorPage } from '../listaGestor/listaGestor';
import { OperadorPedidosPage } from '../operador-pedidos/operador-pedidos';
import { AdiantadorPedidosPage } from '../adiantador-pedidos/adiantador-pedidos';
import { ChangepassPage } from '../changepass/changepass';
import { ForgotPage } from '../forgot/forgot';
import { WelcomePage } from '../welcome/welcome';


//PROVIDERS
import { Tools, User, SyncIO } from '../../providers';

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  title:string='';
  remember: boolean=true;
  account: { username: string, password: string, host:string , type: string} = {
    username: '',
    password: '',
    host:'http://barbosa.ibrs.com.br:4032',
    type: 'MOT'
  };

  constructor(
    public navCtrl: NavController,
    public alertCtrl: AlertController,
    public navParams: NavParams,
    private tools: Tools,
    private user: User,
    private sync: SyncIO
  ) {

    this.tools.storage('load','login',null,(e)=>{
      if(e.status){
        this.remember = true;
        this.account = e.data;
      }
    });
  }

  ionViewDidLoad(){
    console.log(this.navParams.get('item'));
    this.account.type = this.navParams.get('item') + '';
    this.title = this.account.type=='MOT'?'Acesso Motorista':'Acesso Loja';
  }

  login(){
    let loading = this.tools.showLoading('Conectando...');
    loading.present();

    this.account.type = this.navParams.get('item') + '';
    if(this.account.type=='USER'){
      this.account.type = 'CHECK'
    }

    this.user.login(this.account,this.remember,(result)=>{
      this.tools.showAlert('toast',result.msg);
      if(result.status){
        this.sync.connect();
        var user = this.user.getUser();
        if(!user.changePass){
          loading.dismiss();
          this.navCtrl.push(ChangepassPage);
          return;
        }
        if(user.operador){
          if(user.adiantador){
            this.navCtrl.setRoot(AdiantadorPedidosPage,{item:loading});
          }else{
            this.navCtrl.setRoot(OperadorPedidosPage,{item:loading});
          }
        }else if(user.motorista){
          loading.dismiss();
          this.navCtrl.setRoot(EntregasPage);
        }
        else{
          loading.dismiss();
          this.navCtrl.setRoot(ListaGestorPage);
        }
      }else{
        loading.dismiss();
        this.tools.showAlert('toast',result.data.msg);
      }
    });
  }

  openForgot(){
    var item = this.navParams.get('item')=='MOT'?'cadMotoristas':'cadUsuarios';
    this.navCtrl.push(ForgotPage,{item:item});
  }

  logout(){
    let confirm = this.alertCtrl.create({
      title: 'Confirmação',
      message: 'Deseja realmete sair ?',
      buttons: [
        { text: 'Não', handler: () => {} },
        { text: 'Sim', handler: () => { this.navCtrl.setRoot(WelcomePage); } }
      ]
    });
    confirm.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts